module.exports = __webpack_public_path__ + "static/media/tumblr_logo_blue-white_transparent-32.cb108393.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/platforms/tumblr_logo_blue-white_transparent-32.png
 ** module id = 235
 ** module chunks = 0
 **/